module.exports = __webpack_public_path__ + "img/cp1-1.4537437f.jpg";